import React from "react";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

/* news */
import News from "./components/News/index";
import NewsReadMore from "./components/News/readmore";
import NewsAdmin from "./components/Management/NewsAdmin";
import NewCreate from "./components/Management/NewsCreate";
import NewsEdit from "./components/Management/NewsEdit";
import NewsHome from "./components/News/NewsHome";
/* articles */
import ArticlesAdmin from "./components/Management/ArticlesAdmin";
import ArticleCreate from "./components/Management/ArticleCreate";
import Articles from "./components/Articles";
import ArticleEdit from "./components/Management/ArticleEdit";
import ArticlesHome from "./components/Articles/ArticlesHome";
import ThesisList from "./components/Thesis";
import ThesisHome from "./components/Thesis/ThesisHome";
import ThesisAdmin from "./components/Management/ThesisAdmin";
import ThesisCreate from "./components/Management/ThesisCreate";
import ThesisEdit from "./components/Management/ThesisEdit";
/* indicators */
import Indicators from "./components/Indicators";
/* schedule */
//import Schedule from "./components/Schedule";
//import ScheduleCreate from "./components/Management/ScheduleCreate";
//import ScheduleEdit from "./components/Schedule/edit";
//import SchedulesAdmin from "./components/Management/SchedulesAdmin";
/* projects */
import ProjectsAdmin from "./components/Management/ProjectsAdmin";
import Projects from "./components/Projects/index";
import ProjectCreate from "./components/Management/ProjectCreate";
import ProjectEdit from "./components/Management/ProjectEdit";
import ResearchGroups from "./components/Projects/ResearchGroups";
import ResearchGroupsAdmin from "./components/Management/ResearchGroupsAdmin";
import StudyGroupsAdmin from "./components/Management/StudyGroupsAdmin";
import StudyGroups from "./components/Projects/StudyGroups";
//import Qualification from "./components/Projects/Qualification";
import Observatories from "./components/Projects/Observatories";
/* practices */
import Practices from "./components/Practices/index";
import PracticesHome from "./components/Practices/PracticesHome";
import PracticesAdmin from "./components/Management/PracticesAdmin";
import PracticesCreate from "./components/Management/PracticesCreate";
import PracticesEdit from "./components/Management/PracticesEdit";
/* members */
import Members from "./components/Members/index";
import MembersHome from "./components/Members/MembersHome"; // lista simplificada para a home
import MembersAdmin from "./components/Management/MembersAdmin";
import MemberCreate from "./components/Management/MemberCreate";
import MemberEdit from "./components/Management/MemberEdit";
/* general */
import LeiaMais from "./components/Utils/LeiaMais";
import SignIn from "./components/Login/index";
import Management from "./components/Management/index";
import MailTo from "./components/Form/MailTo";
import StoreProvider from "./components/Store/Provider";
import RoutesPrivate from "./components/Routes/Private/Private";
/* observatories */
import ObservatoriesAdmin from "./components/Management/ObservatoriesAdmin";

const App = () => {
  return (
    <BrowserRouter>
      <StoreProvider>
        <nav
          className="navbar navbar-expand-lg navbar-light fixed-top"
          id="mainNav"
        >
          <div className="container px-4 px-lg-5">
            <a className="navbar-brand" href="/#page-top">
              Observatório IFSul
            </a>
            <button
              className="navbar-toggler navbar-toggler-right"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarResponsive"
              aria-controls="navbarResponsive"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              Menu
              <i className="fas fa-bars"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/#sobre">
                    Sobre
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#equipe">
                    Equipe
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#noticias">
                    Notícias
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#producoes">
                    Produções
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#praticas">
                    Práticas
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#projetos">
                    Projetos
                  </a>
                </li>

                {/*
                <li className="nav-item">
                  <a className="nav-link" href="/#indicadores">
                    Indicadores
                  </a>
                </li>
                */}

                <li className="nav-item">
                  <a className="nav-link" href="/#contato">
                    Contato
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <Switch>
          <RoutesPrivate
            path="/management/articles/admin"
            component={ArticlesAdmin}
          />
          <RoutesPrivate
            path="/management/articles/create"
            component={ArticleCreate}
          />
          <RoutesPrivate
            path="/management/articles/edit/:id"
            component={ArticleEdit}
          />

          <RoutesPrivate path="/management/news/admin" component={NewsAdmin} />
          <RoutesPrivate path="/management/news/create" component={NewCreate} />
          <RoutesPrivate
            path="/management/news/edit/:id"
            component={NewsEdit}
          />

          <RoutesPrivate
            path="/management/members/admin"
            component={MembersAdmin}
          />
          <RoutesPrivate
            path="/management/members/create"
            component={MemberCreate}
          />
          <RoutesPrivate
            path="/management/members/edit/:id"
            component={MemberEdit}
          />
          <RoutesPrivate
            path="/management/practices/create"
            component={PracticesCreate}
          />
          <RoutesPrivate
            path="/management/practices/edit/:id"
            component={PracticesEdit}
          />
          <RoutesPrivate
            path="/management/practices/admin"
            component={PracticesAdmin}
          />
          <RoutesPrivate
            path="/management/projects/create"
            component={ProjectCreate}
          />
          <RoutesPrivate
            path="/management/projects/edit/:id"
            component={ProjectEdit}
          />
          <RoutesPrivate
            path="/management/projects/admin"
            component={ProjectsAdmin}
          />
          <RoutesPrivate
            path="/management/research_groups/admin"
            component={ResearchGroupsAdmin}
          />
          <RoutesPrivate
            path="/management/study_groups/admin"
            component={StudyGroupsAdmin}
          />
          <RoutesPrivate
            path="/management/thesis/create"
            component={ThesisCreate}
          />
          <RoutesPrivate
            path="/management/thesis/edit/:id"
            component={ThesisEdit}
          />
          <RoutesPrivate
            path="/management/thesis/admin"
            component={ThesisAdmin}
          />
          <RoutesPrivate
            path="/management/observatories/admin"
            component={ObservatoriesAdmin}
          />

          <RoutesPrivate path="/management" component={Management} />

          <Route path="/articles" component={Articles} />
          <Route path="/thesis" component={ThesisList} />
          <Route path="/practices" component={Practices} />
          <Route path="/news" component={News} />
          <Route path="/readmore/:titulo" component={NewsReadMore} />
          <Route path="/members" component={Members} />
          <Route path="/observatories" component={Observatories} />
          <Route path="/research_groups" component={ResearchGroups} />
          <Route path="/projects" component={Projects} />
          <Route path="/study_groups" component={StudyGroups} />
          <Route path="/login" component={SignIn} />

          <Route path="/indicators" component={Indicators} />
          <Route path="/">
            <header className="masthead pt-5">
              <div className="container px-4 px-lg-5 pb-5 d-flex h-100 align-items-center justify-content-center">
                <div className="d-flex justify-content-center">
                  <div className="text-center">
                    <h1 className="mx-auto my-0 text-uppercase">
                      <img
                        src="/img/logo grande.png"
                        alt="logotipo escrito observatório ifsul"
                        className="img-fluid logo"
                      />
                    </h1>

                    <a className="btn btn-primary " href="#about">
                      Saiba Mais
                    </a>
                  </div>
                </div>
              </div>
            </header>

            <section id="about">
              <div className="container px-4 px-lg-5 py-5" id="sobre">
                <div className="row text-center gx-4 gx-lg-5 justify-content-center mx-5">
                  <h2 className="text-white mb-4">Sobre o Observatório</h2>
                </div>

                <div className="row gx-4 gx-lg-1 justify-content-center mx-5 mt-5">
                  <div className="text-white-50 text-center">
                    O{" "}
                    <b>
                      Observatório da Educação Profissional e Tecnológica (EPT)
                    </b>{" "}
                    do IFSul se constituir em um repositório com dados e
                    informações sobre a EPT e tem por objetivo reunir
                    estudantes, trabalhadores e pesquisadores que tenham
                    interesse em compartilhar ideias, temas e pesquisas sobre
                    Educação Profissional e mundo do trabalho em interfaces com
                    outras temáticas. Promove atividades de extensão, pesquisas
                    e estudos visando qualificar o processo educacional e dos
                    trabalhadores em educação.
                    <br />
                    <MailTo
                      className="link"
                      email="observatorioept.ifsul@gmail.com"
                      subject="Olá"
                      body="Olá, estou entrando em contato a partir do site do Observatório da EPT do IFSul."
                    >
                      Entre em contato através do nosso e-mail!
                    </MailTo>
                    <br />
                    <br />
                    <LeiaMais content={"Leia mais!"}>
                      O projeto de desenvolvimento, implantação, suporte e
                      manutenção do site para o{" "}
                      <b>
                        Observatório da Educação Profissional e Tecnológica do
                        IFSUL
                      </b>{" "}
                      contemplado no Edital Fapergs 04/2020 - apoio a projetos
                      de pesquisa aplicada dos institutos federais em parceria
                      com instituições demandantes – IFSul, Fapergs e Sinasefe é
                      uma demanda do Sindicato Nacional dos Servidores Federais
                      da Educação Básica, Profissional e Tecnológica (SINASEFE),
                      seção sindical IFSUL e tem como objetivo implementar a
                      criação de um portal na web que abarque as produções,
                      pesquisas, indicadores e informações estatísticas;
                      análises de pesquisadores especialistas em Educação
                      Profissional, Trabalho; estudos de Organismos
                      Internacionais; informações sobre organização e luta de
                      categorias, movimentos sociais e práticas já realizadas
                      sobre Educação Profissional e Tecnológica (EPT), tendo em
                      vista contribuir com os diferentes processos políticos e
                      educacionais do IFSUL e do SINASEFE -seção sindical do
                      IFSUL.
                    </LeiaMais>
                  </div>
                </div>
              </div>
            </section>

            <section className="text-center" id="equipe">
              <div className="row gx-4 gx-lg-1 pt-5 justify-content-center mx-5">
                <h2 className="text-black mb-4">Equipe</h2>
              </div>

              <div className="row mx-5">
                <MembersHome />
              </div>

              <div className="row mx-5">
                <div className="col md-4 pb-4">
                  <a className="btn btn-primary" href="/members">
                    Mais Membros
                  </a>
                </div>
              </div>
            </section>

            <section className="text-center" id="noticias">
              <div className="row gx-4 gx-lg-1 pt-5 justify-content-center mx-5">
                <h2 className="text-black mb-4">Notícias</h2>
              </div>

              <div className="row mx-5">
                <NewsHome newsToShow="8" />
              </div>

              <div className="row mx-5">
                <div className="col md-4 pb-3">
                  <a className="btn btn-primary" href="/news">
                    Mais notícias
                  </a>
                </div>
              </div>
            </section>

            <section id="producoes">
              <div className="px-4 px-lg-5 py-5">
                <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                  <h2 className="text-center mb-4">Produções</h2>
                </div>

                <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                  <div className="col-lg-6">
                    <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                      <h2 className="text-center mb-4">Artigos</h2>
                    </div>

                    <ArticlesHome articlesToShow="4" />

                    <div className="text-center col md-4 pb-4">
                      <Link className="btn btn-primary" to="/articles">
                        Mais artigos
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                      <h2 className="text-center mb-4">Teses e Dissertações</h2>
                    </div>

                    <ThesisHome thesisToShow="4" />

                    <div className="text-center col md-4 pb-4">
                      <Link className="btn btn-primary" to="/thesis">
                        Mais Teses e Dissertações
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="projetos">
              <div className="container px-4 px-lg-5 py-5">
                <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                  <h2 className="text-white text-center mb-4">
                    Pesquisa e Formação
                  </h2>
                </div>
                <div className="row gx-4 gx-lg-5 justify-content-center mx-5">
                  {/*
                  <div className="col-lg-8">
                    <p className="text-white-50 text-end">
                      Texto de apresentação do site Texto de apresentação do
                      site Texto de apresentação do site Texto de apresentação
                      do site Texto de apresentação do site Texto de
                      apresentação do site. Texto de apresentação do site Texto
                      de apresentação do site Texto de apresentação do site
                      Texto de apresentação do site Texto de apresentação do
                      site Texto de apresentação do site. Texto de apresentação
                      do site Texto de apresentação do site Texto de
                      apresentação do site Texto de apresentação do site Texto
                      de apresentação do site Texto de apresentação do site.{" "}
                    </p>
                  </div>
                  */}
                  <div className="col-lg-4">
                    <ul>
                      <li className="py-2">
                        <a href="/projects">Projetos de Pesquisa</a>
                      </li>
                      <li className="py-2">
                        <a href="/research_groups">Grupos de Pesquisa</a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul>
                      <li className="py-2">
                        <a href="/study_groups">Grupos de Estudo</a>
                      </li>
                      {/*
                      <li className="py-2">
                        <a href="atividades_formacao.html">
                          Atividades de Formação
                        </a>
                      </li>
                      */}
                      <li className="py-2">
                        <a href="/observatories">Outros Observatórios</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="text-center" id="praticas">
              <div className="row gx-4 gx-lg-1 pt-5 justify-content-center mx-5">
                <h2 className="text-black mb-4">Práticas</h2>
              </div>

              <div className="row mx-5">
                <PracticesHome practicesToShow="4" />
              </div>

              <div className="row mx-5">
                <div className="col md-4 pb-4">
                  <a className="btn btn-primary" href="/practices">
                    Mais práticas
                  </a>
                </div>
              </div>
            </section>

            {/*
            <section id="indicadores">
              <div className="container px-4 px-lg-5 py-5">
                <div className="row text-center gx-4 gx-lg-5 justify-content-center">
                  <h2 className="text-white mb-4">Subtítulo (Indicadores)</h2>
                </div>
                <div className="row gx-4 gx-lg-1 justify-content-center">
                  <div className="col-lg-8">
                    <p className="text-white-50">
                      Texto de apresentação do site Texto de apresentação do
                      site Texto de apresentação do site Texto de apresentação
                      do site Texto de apresentação do site Texto de
                      apresentação do site Texto de apresentação do site Texto
                      de apresentação do site Texto de apresentação do site
                      Texto de apresentação do site Texto de apresentação do
                      site Texto de apresentação do site Texto de apresentação
                      do site Texto de apresentação do site Texto de
                      apresentação do site Texto de apresentação do site Texto
                      de apresentação do site Texto de apresentação do site
                    </p>
                  </div>
                  <div className="col-lg-4">
                    <img
                      className="img-fluid"
                      src="assets/img/grafico.jpg"
                      alt="..."
                    />
                  </div>
                </div>
                <div className="row mx-5">
                  <div className="col md-4 pb-3">
                    <a className="btn btn-primary" href="/indicators">
                      Mais Indicadores
                    </a>
                  </div>
                </div>
              </div>
            </section>
                    */}

            <section id="contato" className="contact-section bg-black">
              <div className="container px-4 px-lg-5">
                <div className="d-flex justify-content-center">
                  <div className="col-md-4 mb-3 mb-md-0">
                    <div className="card py-4 h-100">
                      <div className="card-body text-center">
                        <i className="fas fa-envelope text-primary mb-2"></i>
                        <h4 className="text-uppercase m-0">Email</h4>
                        <hr className="my-4 mx-auto" />
                        <div className="small text-black-50">
                          <MailTo
                            className="link"
                            email="observatorioept.ifsul@gmail.com"
                            subject="Olá"
                            body="Olá, estou entrando em contato a partir do site do Observatório da EPT do IFSul."
                          >
                            Entre em contato através do nosso e-mail!
                          </MailTo>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="social d-flex justify-content-center">
                  <a
                    className="mx-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/observatorioifsul"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>

                  <a
                    className="mx-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/c/observatorioeptifsul"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </section>
          </Route>
        </Switch>

        <footer className="footer bg-black small text-center text-white-50">
          <div className="container px-4 px-lg-5">
            <div className="row">
              <div className="col-md-4">
                <img
                  src="/img/logo_ifsul.png"
                  alt="Logotipo do IFSul"
                  width="300px"
                />
              </div>

              <div className="col-md-4">
                <img
                  src="/img/logo_fapergs_negativo_2.png"
                  alt="Logotipo da FAPERGS"
                  width="200px"
                />
              </div>

              <div className="col-md-4">
                <img
                  src="/img/logo_sinasefeifsul.png"
                  alt="Logotipo do SINASEFE IFSul"
                  width="300px"
                />
              </div>
            </div>
            <br />
            Copyright &copy; Todos os direitos reservados para Observatório da
            Educação Profissional e Tecnológica (EPT) do IFSul
          </div>

          <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>

          <script src="/scripts.js"></script>
          <script src="https://cdn.startbootstrap.com/sb-forms-latest.js"></script>
        </footer>
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
